export const loadTrackingScripts = () => {
  if (process.env.NODE_ENV !== "production") return;

  // Insert Google Tag Manager
  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-NCV8N6DXP6";
  document.head.appendChild(gtagScript);

  const gtagConfig = document.createElement("script");
  gtagConfig.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-NCV8N6DXP6');
  `;
  document.head.appendChild(gtagConfig);

  // Insert Facebook Pixel
  const fbPixel = document.createElement("script");
  fbPixel.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '2973679556189144');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(fbPixel);

  const fbNoScript = document.createElement("noscript");
  fbNoScript.innerHTML = `
    <img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=2973679556189144&ev=PageView&noscript=1"/>
  `;
  document.body.appendChild(fbNoScript);
};
